<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive" class="page"></router-view>
    </keep-alive>
    <router-view
      v-if="!$route.meta.keepAlive"
      :key="$route.fullPath"
    ></router-view>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {},
  created() {
    // 授权逻辑已移除，改为在各个页面需要时单独调用
    // 避免在 App.vue 中统一处理导致无限循环
  }
};
</script>

<style lang="scss">
img {
  border: 0 none;
  max-width: 100%;
  vertical-align: middle;
}
.text-center {
  text-align: center !important;
}
.text-right {
  text-align: right !important;
}
.t12 {
  font-size: 12px !important;
}
.t13 {
  font-size: 13px !important;
}
.t14 {
  font-size: 14px !important;
}
.t15 {
  font-size: 15px !important;
}
.t16 {
  font-size: 16px !important;
}
.t18 {
  font-size: 18px !important;
}
.t21 {
  font-size: 21px !important;
}
.t24 {
  font-size: 24px !important;
}
small {
  font-size: 65%;
}
.cred {
  color: #d54d4d !important;
}
.cgreen {
  color: #6ebd05 !important;
}
.corange {
  color: #e78639 !important;
}
.hlight {
  color: #f3354f !important;
}
.c0 {
  color: #141414 !important;
}
.c2 {
  color: #222 !important;
}
.c3 {
  color: #333 !important;
}
.c4 {
  color: #444 !important;
}
.c5 {
  color: #555 !important;
}
.c6 {
  color: #666 !important;
}
.c7 {
  color: #777 !important;
}
.c8 {
  color: #888 !important;
}
.c9 {
  color: #999 !important;
}
.ca {
  color: #a6a6a6 !important;
}
.cb {
  color: #bbb !important;
}
.cc {
  color: #ccc !important;
}
.ce {
  color: #eee !important;
}
.hidden {
  display: none;
}
.header {
  width: 100%;
  background-color: #fff;
  position: relative;
}
.header-text {
  width: 100%;
  height: 50px;
  line-height: 50px;
  text-align: center;
  font-size: 16px;
  color: #333;
}
.backBox {
  position: absolute;
  width: 15px;
  left: 13px;
  line-height: 53px;
}
.backBox > img {
  width: 8px;
  vertical-align: middle;
}
.header-fix {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 99;
  width: 100%;
}
header ul li {
  width: 100%;
  height: 50px;
  line-height: 50px;
  text-align: center;
  display: none;
  color: #323232;
  position: relative;
  font-size: 18px;
}

header ul li.active {
  width: 100%;
  display: block;
}

.headerSpace {
  padding-top: 50px;
}
.goods-area {
  margin-right: -10px;
  overflow: hidden;
}
.van-nav-bar .van-icon {
  font-size: 20px;
  color: #333;
}
.van-nav-bar__left,
.van-nav-bar__right {
  padding: 0 10px;
}
.van-cell-group {
  margin: 10px 0;
}
.van-nav-bar__text {
  color: blue !important;
}
.flexbox {
  display: flex;
  align-items: center;
}
.flexmid {
  flex: 1;
}
.clearfix {
  overflow: auto;
  zoom: 1;
}
.filter {
  display: flex;
  height: 44px;
  line-height: 44px;
  overflow: hidden;
  box-sizing: content-box;
}
.filter-item {
  flex: 1;
  text-align: center;
}
.filter-item .navigation {
  height: 44px;
  line-height: 44px;
}
.filter-item.active .navigation {
  color: #000;
}
.filter-item.active[data-sort] .filter-item-price::before {
  border-bottom-color: #ff2e56;
}
.filter-item.active[data-sort="asc"] .filter-item-price::before {
  border-bottom-color: #ff2e56;
}
.filter-item.active[data-sort="asc"] .filter-item-price::after {
  border-top-color: #b4babf;
}
.filter-item.active[data-sort="desc"] .filter-item-price::before {
  border-bottom-color: #b4babf;
}
.filter-item.active[data-sort="desc"] .filter-item-price::after {
  border-top-color: #ff2e56;
}
.filter-item-price {
  position: relative;
  top: 1px;
  margin-left: 4px;
}
.filter-item-price::after,
.filter-item-price::before {
  content: "";
  display: block;
  position: absolute;
  top: -1px;
  left: 0;
  width: 0;
  height: 0;
  font-size: 0;
  border: 4px solid transparent;
}
.filter-item-price::before {
  border-bottom-color: #b4babf;
}
.filter-item-price::after {
  border-top-color: #b4babf;
  top: 8px;
}
.btn-area {
  padding: 20px 15px;
}
.change-btn {
  width: 76%;
  height: 2.3rem;
  background-color: #ff669e;
  border-radius: 90px;
  text-align: center;
  line-height: 2.3rem;
  margin: auto;
  margin-top: 2.2rem;
  font-size: 0.8rem;
  color: #fff;
}
.noLogin {
  width: 100%;
  height: auto;
  padding-top: 2.5rem;
}

.noLogin > div {
  width: 7rem;
  height: 2.3rem;
  font-size: 0.71rem;
  color: #f3354f;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: auto;
  margin-top: 2rem;
  border-radius: 0.25rem;
  border: 0.05rem solid #f3354f;
}

.noLogin > img {
  width: 4.5rem;
  height: 4.5rem;
  display: block;
  margin: auto;
}

// 无数据
.nodata-box {
  display: flex;
  align-items: center;
  flex-direction: column;
  padding-top: 15%;
  padding-bottom: 32px;
  .thumb {
    width: 106px;
    height: auto;
  }
  .tips {
    font-size: 12px;
    color: #a4a4a4;
    margin-top: 16px;
  }
}

/* 优惠券 */
.coupon {
  width: 17.142857142857142rem;
  height: 4.666666666666667rem;
  background: url(~@/assets/image/coupon-item-bg.png) center center no-repeat;
  background-size: 100% 100%;
  margin: 0.38095238095238093rem auto;
  display: flex;
  position: relative;
}
.coupon {
  .l {
    color: #fff;
    display: flex;
    align-items: center;
    flex: 1;
    overflow: hidden;
    .hd {
      width: 3.1904761904761907rem;
      height: 3.1904761904761907rem;
      margin-right: 0.2857142857142857rem;
      margin-left: 0.38095238095238093rem;
      position: relative;
      flex-shrink: 0;
      .thumb {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        border-radius: 0.14285714285714285rem;
        object-fit: cover;
      }
    }
    .bd {
      position: relative;
      padding-right: 0.38095238095238093rem;
      flex: 1;
      overflow: hidden;
      .title {
        font-size: 0.5714285714285714rem;
        color: #000000;
        margin-bottom: 0.09523809523809523rem;
      }
      .date {
        font-size: 0.47619047619047616rem;
        color: #eb001d;
      }
      .des {
        font-size: 0.47619047619047616rem;
        color: #303030;
        margin-top: 0;
        transform: scale(0.8);
        transform-origin: left center;
      }
      .check-icon {
        position: absolute;
        top: 50%;
        bottom: 0;
        right: 0.38095238095238093rem;
        width: 0.7619047619047619rem;
        height: 0.7619047619047619rem;
      }
    }
  }
  .r {
    flex-shrink: 0;
    width: 4.571428571428571rem;
    display: flex;
    box-sizing: border-box;
    flex-direction: column;
    justify-content: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 0 0.2857142857142857rem;
    position: relative;
    .r-bd {
      flex: 1;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      .coupon-price {
        font-size: 0.7142857142857143rem;
        color: #fff;
        .price {
          font-size: 1.1428571428571428rem;
          font-weight: bold;
        }
      }
      .xianzhi {
        font-size: 0.47619047619047616rem;
        color: #fff;
        text-align: center;
      }
    }
    .used-price {
      border-top: 0.047619047619047616rem solid rgba(255, 255, 255, 0.4);
      font-size: 0.47619047619047616rem;
      padding: 0.38095238095238093rem 0;
      color: #fff;
      .price {
        font-size: 0.6190476190476191rem;
      }
    }
    .coupon-tag {
      position: absolute;
      top: -0.23809523809523808rem;
      right: -0.38095238095238093rem;
      width: 2.2857142857142856rem;
      height: 2.2857142857142856rem;
      object-fit: contain;
    }
  }

  .van-overlay {
    background-color: rgba(0, 0, 0, 0.65);
  }
  .van-image-preview__overlay {
    background-color: rgba(0, 0, 0, 0.9) !important;
  }
}

.search {
  position: fixed;
  width: 100%;
  z-index: 999;
}

input[type="search"] {
  -webkit-appearance: none;
}
[type="search"]::-webkit-search-decoration {
  display: none;
}
input::-webkit-search-cancel-button {
  display: none;
}

.cservice-code {
  position: fixed;
  bottom: 160px;
  right: 5px;
  width: 45px;
  height: 45px;
  z-index: 999;
}


.qfollow-code {
  position: fixed;
  bottom: 110px;
  right: 5px;
  width: 45px;
  height: 45px;
  z-index: 88;
}

.qcode_main {
  text-align: center;
  .title_gz {
    font-size: 24px;
    font-weight: 550;
    margin-top: 15px;
  }

  .title {
    font-size: 16px;
    font-weight: 550;
    margin-top: 15px;
    display: flex;
    justify-content: center;
    .copy {
      font-size: 0.57rem;
      color: #ff4b8a;
      border: 0.05rem solid #ff4b8a;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 0.2rem;
      padding: 0.05rem 0.4rem;
      margin-left: 0.5rem;
    }
  }

  .img {
    width: 250px;
    height: 250px;
  }

  .img2 {
    width: 215px;
    height: 215px;
    margin: 15px 0px;
  }

  .text {
    font-size: 17px;
    font-weight: 550;
    margin-bottom: 15px;
  }
  .text02 {
    font-size: 16px;
    font-weight: 550;
    margin-bottom: 15px;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue